<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">edit_note</v-icon> Mon formulaire d'adhésion
            </span>
        </div>

        <v-card class="p-2 mb-5">
            <v-card-text>
                <h4 class="mb-5">Titre du formulaire</h4>

                <v-text-field
                  outlined
                  v-model="formTittle"
                  hide-details
                ></v-text-field>
            </v-card-text>
        </v-card>

        <v-card class="p-4 mb-5">
            <h4 class="mb-5">Texte d'introduction du formulaire</h4>
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="txtIntro"
            ></ckeditor>
        </v-card>

        <v-card class="p-4 mb-5">
            <h4 class="mb-5">Informations administratives</h4>
            <v-alert type="info" text class="mb-5">
                Sélectionnez les champs à renseigner par vos pros pour la validation du formulaire.
            </v-alert>
            <v-data-table
              :headers="headers"
              :items="informations"
              :hide-default-footer="true"
              :items-per-page="20"
            >
                <template v-slot:item.label="{ item }">
                    <div>{{ item.label }}</div>
                </template>

                <template v-slot:item.check="{ item }">
                    <div>
                        <v-checkbox class="mt-0 mr-5"
                                    style="padding-top: 0 !important;"
                                    v-model="item.check"
                                    @change="removeRequired(item)"
                                    hide-details>
                        </v-checkbox>
                    </div>
                </template>

                <template v-slot:item.required="{ item }">
                    <div>
                        <v-checkbox class="mt-0 mr-5"
                                    style="padding-top: 0 !important;"
                                    v-model="item.required"
                                    @change="autoCheck(item)"
                                    hide-details>
                        </v-checkbox>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <v-card class="p-4 mb-5">
            <h4 class="mb-5">Texte de remerciement</h4>
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="thanksText"
            ></ckeditor>
        </v-card>

        <v-card class="p-4 mb-5">
            <h4 class="mb-5">E-mail de remerciement</h4>

            <h5 class="mb-5">Objet</h5>
            <v-text-field
              outlined
              v-model="emailObject"
              hide-details
            ></v-text-field>

            <h5 class="my-5">Première partie de l'e-mail</h5>
            <ckeditor
              :editor="editor"
              v-model="emailPart1"
            ></ckeditor>

            <div class="text-center valid-button">
                <adh-summary-example></adh-summary-example>
            </div>

            <h5 class="my-5">Dernière partie de l'e-mail</h5>
            <ckeditor
              :editor="editor"
              v-model="emailPart2"
            ></ckeditor>
        </v-card>

        <v-card class="p-2 mb-5">
            <v-card-text>
                <h4 class="mb-5">Titre du bulletin d'adhésion</h4>

                <v-text-field
                  outlined
                  v-model="answerPdfittle"
                  hide-details
                ></v-text-field>
            </v-card-text>
        </v-card>

        <div class="d-flex flex-row-reverse">
            <div class="text-right mb-10 ml-2">
                <v-btn
                  class="default-button mt-3"
                  @click="saveConfig"
                >
                    <v-icon>save</v-icon>
                    Enregistrer tout
                </v-btn>
            </div>
            <div class="mb-10">
                <v-tooltip slot="append-outer" bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn class="custom-button-primary mt-3" outlined @click="openPreview"
                               :disabled="account.cadh_configurations.length === 0 || configToken in ['', null] " v-on="on">
                            <v-icon class="mr-2">remove_red_eye</v-icon>
                            Voir le formulaire
                        </v-btn>
                    </template>
                    <span>Pour visualiser vos modifications dans le formulaire, pensez à les enregistrer avant.</span>
                </v-tooltip>


            </div>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import ClassicEditor from "../../../plugins/ckeditor"
import { mapState } from "vuex"
import _ from "lodash"
import Confirm from "@/components/tools/Confirm.vue"
import AdhSummaryExample from "@/components/configuration/AdhSummaryExample.vue"

export default {
    name: "CadhConfig",
    components: { Confirm, AdhSummaryExample },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    shouldNotGroupWhenFull: true,
                    items: [
                        'heading',
                        '|',
                        'alignment',
                        'bold',
                        'italic',
                        'underline',
                        'fontSize',
                        'fontColor',
                        'fontBackgroundColor',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                        'blockQuote',
                        'undo',
                        'redo'
                    ]
                },
            },
            formTittle: null,
            txtIntro: '',
            configurations: [],
            adminConfigurations: [],
            thanksText: '',
            emailObject: null,
            emailPart1: '',
            emailPart2: '',
            showAdress: false,
            informations: [],
            fields: [],
            headers: [
                {
                    text: "Information",
                    align: "start",
                    sortable: false,
                    value: "label",
                },
                {
                    text: "Demandé",
                    align: "start",
                    sortable: false,
                    value: "check",
                },
                {
                    text: "Obligatoire",
                    align: "start",
                    sortable: false,
                    value: "required",
                },
            ],
            configId: null,
            answerPdfittle: "",
            configToken: '',
        }
    },
    methods: {
        getCadhFields() {
            this.$http.get("adhesion/config/fields").then(res => {
                this.fields = Object.values(res.body.data.cadhFields)
            })
        },
        getConfig: _.debounce(function() {
            this.getCadhFields()

            if (this.account.cadh_configurations.length > 0) {
                this.configId = this.account.cadh_configurations.at(-1).id

                this.$http.get("adhesion/config/" + this.configId).then(res => {
                    this.code = 200

                    this.configurations = res.body.data.config.configuration_keys
                    this.adminConfigurations = res.body.data.config.cadh_fields

                    this.txtIntro = this.getConfigValue("introduction")
                    this.formTittle = this.getConfigValue("titre_general")
                    this.thanksText = this.getConfigValue("remerciement_1")
                    this.emailObject = this.getConfigValue("email_remerciement_subject")
                    this.emailPart1 = this.getConfigValue("email_remerciement_part_1")
                    this.emailPart2 = this.getConfigValue("email_remerciement_part_2")
                    this.configToken = res.body.data.config.token

                    if (this.getConfigValue("answer_pdf_title") === null) {
                        if (this.getConfigValue("global_partenariat") === "1") {
                            this.answerPdfittle = "Contrat de partenariat"
                        } else {
                            this.answerPdfittle = "Contrat d'adhésion"
                        }
                    } else {
                        this.answerPdfittle = this.getConfigValue("answer_pdf_title")
                    }

                    this.setInformationsBooleans()
                })
            }
        }, 500),
        getConfigValue(key) {
            let value = null
            let config = this.configurations.find(conf => conf.key === key)

            if (config !== undefined && config !== null) {
                value = config.value
            }

            return value
        },
        getAdminConfig(code) {
            return this.adminConfigurations.find(conf => conf.code === code)
        },
        setInformationsBooleans() {
            this.informations = []

            this.fields.forEach(field => {
                let data = this.getAdminConfig(field.code)
                let information = {}

                if (data !== undefined && data !== null) {
                    information = {
                        label: field.label,
                        code: field.code,
                        check: true,
                        required: data.pivot.required,
                    }
                } else {
                    information = {
                        label: field.label,
                        code: field.code,
                        check: false,
                        required: false,
                    }
                }
                this.informations.push(information)
            })
        },
        saveConfig() {
            this.$refs.confirm.open("Attention", "Vos modifications s'appliqueront à vos campagnes d'adhésion en cours. " +
              "Êtes-vous sûr de vouloir les enregistrer ?", { color: "red" }).then((confirm) => {
                if (confirm) {
                    let payload = {
                        txtIntro: this.txtIntro,
                        formTittle: this.formTittle,
                        thanksText: this.thanksText,
                        emailObject: this.emailObject,
                        emailPart1: this.emailPart1,
                        emailPart2: this.emailPart2,
                        informations: this.informations,
                        answerPdfTitle: this.answerPdfittle,
                    }

                    this.$global.loading = true

                    this.$http.post("auth/account/cadh-config/update", payload).then((res) => {
                        this.$global.loading = false
                        this.getConfig()
                    })
                }
            })
        },
        autoCheck(item) {
            if (item.check === false) {
                item.check = true
            }
        },
        removeRequired(item) {
            if (item.check === false) {
                item.required = false
            }
        },
        openPreview() {
            let url = window.location.origin + "/cadh-preview/" + this.configToken

            window.open(url)
        },
    },
    computed: {
        ...mapState("account", ["account"]),
    },
    created() {
        this.getConfig()
    },
}
</script>